import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/prospects',
    name: 'Prospects',
    // route level code-splitting
    // this generates a separate chunk (prospects.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "prospects" */ '../views/prospects.vue')
    }
  },
  {
    path: '/4c',
    name: '4c',
    component: function () {
      return import(/* webpackChunkName: "4c" */ '../views/4c.vue')
    }
  },
  {
    path: '/result',
    name: 'result',
    component: function () {
      return import(/* webpackChunkName: "result" */ '../views/result.vue')
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: function () {
      return import(/* webpackChunkName: "admin" */ '../views/admin.vue')
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
